export default [
  {
    altText: "Driver Benefits",
    bannerID: "driver-benefits-generic",
    buttonText: "",
    redirectUrl: "https://www.airasia.com/aa/about-us/en/gb/ride-terms-and-conditions.html",
    desktopImage:
      "https://www.airasia.com/aa/ride/benefits/images/hero-banner-generic-en.jpg",
    mobileImage:
      "https://www.airasia.com/aa/ride/benefits/images/hero-banner-generic-mobile-en.jpg",
    tabletImage:
      "https://www.airasia.com/aa/ride/benefits/images/hero-banner-generic-en.jpg",
  }
]
